import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "./sectionHeader.scss";

export default function SectionHeader({ title, subtitle }) {
    const navigate = useNavigate();

    return (
        <div className="section-header">
            <button
                className="section-header__back-button"
                onClick={() => navigate(-1)}
            >
                <FaArrowLeft />
            </button>
            <div className="section-header__text">
                <h1 className="section-header__text__title">{title}</h1>
                {subtitle && (
                    <h2 className="section-header__text__subtitle">
                        {subtitle}
                    </h2>
                )}
            </div>
        </div>
    );
}
